import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';

// const circuitCheckStatusReason = window.localStorage.getItem('statusReason');
const SR_FILTER_OPTIONS = [
  {
    id: 'circuitCheck',
    text: 'Circuit Check',
    values: '10500',
  },
];

const CrqListCircuitCheckFilter = ({
  selectedReason,
  toggleCircuitCheck,
}) => (
  <div className="crq-list-checkbox-filter crq-list-sla-filter">
    <h3>Circuit Check Filter</h3>
    <ul>
      {SR_FILTER_OPTIONS.map(({ id, text }) => {
        const isSelected = selectedReason.includes(id);
        return (
          <li key={id}>
            <OptionButton
              className={`checkbox-option ${isSelected ? 'checkbox-option-selected' : ''}`}
              onClick={toggleCircuitCheck}
              option={id}
            >
              <div className="svg-container">
                {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
              </div>
              {text}
            </OptionButton>
          </li>
        );
      })}
    </ul>
  </div>
);

CrqListCircuitCheckFilter.propTypes = {
  selectedReason: PropTypes.arrayOf(PropTypes.string),
  toggleCircuitCheck: PropTypes.func,
};

export { CrqListCircuitCheckFilter, SR_FILTER_OPTIONS };
